import Vue from 'vue'
import Router from 'vue-router'
import localforage from 'localforage'

import PageNotFound from '@/views/page404'

import Schedule from '@/views/schedule'
import ChangeScheduleSector from '@/views/schedule/change'
import Patient from '@/views/patient/index-new'
import Graph from '@/views/graph'
import Imagens from '@/views/imagens'
import Profile from '@/views/profile'

import Dashboard from '@/views/dashboard'

import Settings from '@/views/settings'

import SingUp from '@/views/auth/Sing-up'
import Register from '@/views/auth/Register'
import UpdateSchedule from '@/views/auth/UpdateSchedule'
import SearchUser from '@/views/auth/SearchUser'
import ResetPassword from '@/views/auth/Reset-password'
import ForgetPassword from '@/views/auth/Forget-password'
import Auth from '@/views/auth/Login'

import SurgeryCenter from '@/views/surgery-center/surgery-center'

import store from '../store'

Vue.use(Router)

const router = new Router({
  mode: 'history', // Demo is living in GitHub.io, so required! hash history
  history: true,
  linkActiveClass: 'is-active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    {
      path: '/proposed-surgeries',
      name: 'proposed-surgeries',
      component: SurgeryCenter,
      meta: { auth: true }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: { auth: true }
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      meta: { auth: true }
    },
    {
      path: '/schedule',
      name: 'Schedule',
      component: Schedule,
      meta: { auth: true }
    },
    {
      path: '/change-schedule',
      name: 'changeSchedule',
      component: ChangeScheduleSector,
      meta: { auth: true }
    },
    {
      path: '/update-schedule',
      name: 'UpdateSchedule',
      component: UpdateSchedule,
      meta: { auth: true }
    },
    {
      path: '/patient',
      name: 'Patient',
      component: Patient,
      meta: { auth: true }
    },
    {
      path: '/graph',
      name: 'Gráficos',
      component: Graph,
      meta: { auth: true }
    },
    {
      path: '/imagem',
      name: 'Imagens',
      component: Imagens,
      meta: { auth: true }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: { auth: true }
    },
    {
      path: '*',
      redirect: '/auth/login'
    },
    {
      path: '/auth/login',
      name: 'Login',
      component: Auth,
      meta: { auth: false }
    },
    {
      path: '/auth/reset-password',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: { auth: false }
    },
    {
      path: '/auth/forget-password',
      name: 'ForgetPassword',
      component: ForgetPassword,
      meta: { auth: false }
    },
    {
      path: '/auth/register',
      name: 'Register',
      component: Register,
      meta: { auth: false }
    },
    {
      path: '/auth/sing-up',
      name: 'Singup',
      component: SingUp,
      meta: {
        auth: false
      }
    },
    {
      path: '/auth/search-user',
      name: 'SearchUser',
      component: SearchUser,
      meta: { auth: false }
    },
    {
      path: '/pagenotfound',
      name: 'PageNotFound',
      component: PageNotFound,
      meta: {
        auth: false
      }
    },
    {
      path: '*',
      redirect: '/auth/login'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if ((to.path === '/auth/reset-password') && (to.query.token !== undefined)) {
    // console.log(to.path)
    // console.log(to.query.token)
    store.dispatch('setTokenRecoveryPassword', to.query.token).then(() => console.log('aaa'))
  }
  const promise = new Promise((resolve, reject) => {
    if (to.path !== '/pagenotfound') {
      if (store.state.auth.token) {
        window.axios.defaults.headers.common['x-access-token'] = store.state.auth.token
      }
      if (to.meta.auth === false) {
        return resolve(next())
      }
      resolve(next())
    } else {
      resolve()
    }
  })

  promise.then(() => {
    const originalPush = Router.prototype.push
    Router.prototype.push = function push (location, onResolve, onReject) {
      if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
      return originalPush.call(this, location).catch(err => err)
    }

    if (to.meta.auth === false) {
      return next()
    }

    if ((to.meta.auth === true) && (!store.state.auth.auth.isLogged)) {
      return next('/auth/login')
    }

    if ((to.meta.auth !== undefined) || (to.meta.auth !== false)) {
      if ((!store.state.auth.auth.isLogged) && (to.path === '/auth/reset-password')) {
        return next('/auth/reset-password')
      } else if ((!store.state.auth.auth.isLogged) && (to.path === '/auth/login')) {
        return next('/auth/login')
      }
    } else {
      return next('/auth/login')
    }
  }).then(() => {
    if ((from.path === '/auth/login') || (from.path === '/')) {
      localforage.getItem('my-clinic-user', async (err, value) => {
        if (err) console.error(err)
        if (!value) return false
        const decoded = atob(value.user.credentials)
        const arrayCredencials = decoded.split(':', 2)
        const auth = {
          username: arrayCredencials[0],
          password: arrayCredencials[1],
          customer: 'asasasa'
        }
        await store.dispatch('auth/setSingIn', auth).then(async (response) => {
          if (response) {
            if (from.path === '/auth/login') {
              await next('/schedule')
            }
          }
        })
      }).catch((err) => window.console.error('err', err))
    }
  }).catch(() => next('/auth/login'))
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js